import { capitalize } from "lodash";
import { ISnackbarOptions } from "./types";

export enum EVALUATION_CATEGORIES {
  STUDENT = "student",
  COACH = "teacher",
  PARENT = "parent",
}

export const COPY_LINK = "Copy link";

export const COPY_ERROR =
  "There was a problem copying the survey link. Please try again.";
export const GET_COPY_SUCCESS = (category: EVALUATION_CATEGORIES, isAdsurvey: any) =>
  `${category === EVALUATION_CATEGORIES.COACH && isAdsurvey === true
    ? "AD"
    : category === "student" && isAdsurvey === true
    ? "Teacher"
    : capitalize(category)
  } survey link copied successfully!`;

export const closedSnackbarOptions: ISnackbarOptions = {
  message: "",
  open: false,
  severity: "info",
};

export const errorSnackbarOptions: ISnackbarOptions = {
  message: COPY_ERROR,
  open: true,
  severity: "error",
};

export const successSnackbarOptions: Omit<ISnackbarOptions, "message"> = {
  open: true,
  severity: "success",
};



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/sport-table/components/survey-link/constants.ts